import { styled } from "@pigment-css/react";

interface EmployeeHeaderProps {
  name: string;
  region: string | null;
  dateSelector?: React.ReactNode;
}

const HeaderWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: theme.managementView.spacing[16],
}));

const HeaderContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.managementView.spacing[6],
}));

const EmployeeName = styled("h2")(({ theme }) => ({
  fontFamily: theme.managementView.font.family,
  fontSize: theme.managementView.font.size[21],
  fontWeight: theme.managementView.font.weight[500],
  letterSpacing: theme.managementView.font.letterSpacing.tight,
  color: theme.managementView.colors.neutral[100],
  margin: 0,
}));

const Region = styled("p")(({ theme }) => ({
  fontFamily: theme.managementView.font.familySecondary,
  fontSize: theme.managementView.font.size[16],
  fontWeight: theme.managementView.font.weight[500],
  color: theme.managementView.colors.neutral[64],
  margin: 0,
}));

const DateSelectorContainer = styled("div")({
  flexShrink: 0,
});

export const EmployeeHeader = ({ name, region, dateSelector }: EmployeeHeaderProps) => {
  return (
    <HeaderWrapper>
      <HeaderContainer>
        <EmployeeName>{name}</EmployeeName>
        {region && <Region>{region}</Region>}
      </HeaderContainer>
      {dateSelector && <DateSelectorContainer>{dateSelector}</DateSelectorContainer>}
    </HeaderWrapper>
  );
};
